<template>
  <div :class="['section-head', { left: align === 'left' }]">
    <div v-if="eyebrow" class="eyebrow">{{ eyebrow }}</div>
    <h2 class="section-title">
      <slot />
    </h2>
    <p v-if="copy" class="section-copy">{{ copy }}</p>
  </div>
</template>

<script>
export default {
  name: 'SectionHead',
  props: {
    eyebrow: { type: String, default: '' },
    copy: { type: String, default: '' },
    align: { type: String, default: 'center' }
  }
};
</script>

<style lang="less" scoped>
.section-head {
  text-align: center;
  max-width: 820px;
  margin: 0 auto 50px;

  &.left {
    text-align: left;
    margin: 0 0 34px;
  }
}
</style>
